/**
 * This is an Attribute-Directive to use on elements with HTML5-Attribute 'contenteditable', allowing the user to
 * modify the text-content of the element directly while taking advantage of angulars two-way-binding.
 * .
 * based on https://stackoverflow.com/a/40183067/1225741
 */

import {
  Directive, ElementRef, Input, Output, EventEmitter, OnChanges, OnInit, HostListener
} from '@angular/core';

@Directive({ selector: '[appContenteditableModel]' })
export class ContentEditableDirective implements OnChanges, OnInit {
  originalText: string;
  /* tslint:disable: no-input-rename no-output-rename */
  @Input('appContenteditableModel') model: string;
  @Output('appContenteditableModelChange') update = new EventEmitter();
  getText = () => this.elementRef.nativeElement.innerText;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.originalText = this.getText();
  }

  /**
   * Apply changes of the model to the HTML-Element
   */
  ngOnChanges(changes) {
    this.elementRef.nativeElement.innerText = this.model;
  }

  /**
   * If the Element loses focus ('blur') and the the originalText has been changed, we emit a change-event
   */
  @HostListener('blur')
  emitChange() {
    if (this.originalText !== this.getText()) {
      this.update.emit(this.getText());
    }
  }

  @HostListener('keydown', ['$event'])
  onKeydown(e) {
  }

  @HostListener('keypress', ['$event'])
  onKeyTyped(e) {
  }


}
